import { useEffect, useState } from "react";
import Card from "../card/Card";
import { Dropdown } from "../inputs/Dropdown";
import { useListRecords } from "../../server/hooks/getData";
import { TextInput } from "../inputs/TextInput";
import { SecondaryButton } from "../buttons/SecondaryButton";
import { save } from "../../assets/icons";
import Inline from "../inline/Inline";
import { formatTimestamp, timestamp } from "../../lib/dateHelper";
import { createRecord, updateRecord } from "../../server/fetchFunctions";
import "./timeline.css";
import { Loader } from "../loader/Loader";
import { pattern } from "../../lib/pattern";

export default function TimeLine({ id, setJob }: { id: string; setJob: React.Dispatch<React.SetStateAction<any>> }) {
  const [instance, setInstance] = useState<{ [key: string]: any }>({});
  const [timeline, setTimeline] = useState<{ [key: string]: any }[]>([]);
  const [load, setLoad] = useState(true);
  const { data: statuses, loading: statusL } = useListRecords("status", [], {});
  const { data: initTimeline, loading: timelineL } = useListRecords("timeline", [id], {
    job_id: id,
    orderBy: "id",
    order: "DESC",
  });

  useEffect(() => {
    if (!statusL && !timelineL) {
      setTimeline(
        initTimeline.data.map((item) => {
          const status = statuses.data.find((status) => status.id === item.status_id);

          return {
            ...item,
            status_color: status.color,
          };
        })
      );
    }
    setLoad(false);
  }, [initTimeline, statuses]);

  const handleClick = async () => {
    const status = statuses.data.find((status) => status.id === instance.status_id);
    const newInstance = {
      job_id: id,
      note: instance.description,
      status_id: instance.status_id,
      status_name: instance.status_name,
      status_color: status.color,
      timestamp: timestamp(),
    };
    setTimeline((prev) => [newInstance, ...prev]);
    await createRecord("timeline", newInstance);
    await updateRecord("jobs", id, { status_id: instance.status_id });
    setJob((prev: any) => ({ ...prev, status_id: instance.status_id }));
  };

  return (
    <Card title="Idővonal">
      <Inline>
        <div style={{ width: "25%" }}>
          <Dropdown
            placeholder="Státusz"
            state={instance}
            setState={setInstance}
            stateKey="type"
            list={statuses.data}
            listKeys={["status_name"]}
            listTarget="id"
            handleClick={(item: any) =>
              setInstance((prev) => ({
                ...prev,
                status_id: item.id,
                status_name: item.status_name,
              }))
            }
          />
        </div>
        <div style={{ flexGrow: 1 }}>
          <TextInput
            stateKey="description"
            inlineLabel="Leírás"
            state={instance}
            setState={setInstance}
            pattern={pattern.normal_text}
          />
        </div>
        <div style={{ flexGrow: 0 }}>
          <SecondaryButton btn={{ text: save, onClick: handleClick }} />
        </div>
      </Inline>
      <div className="inline-list">
        {load ? (
          <Loader />
        ) : (
          timeline.map((item: any) => (
            <div key={item.id} className="timeline-items">
              <div className="status">
                <span style={{ background: item.status_color, color: "#22252a" }}>{item.status_name}</span>
              </div>
              <div className="description">{item.note}</div>
              <div className="timestamp" style={{ marginLeft: "auto" }}>
                {formatTimestamp(item.timestamp)}
              </div>
            </div>
          ))
        )}
      </div>
    </Card>
  );
}
